    import React, { useState, ReactNode, useEffect } from 'react';
    import { Layout } from 'antd';
    import Sidebar from './Sidebar';
    import Navbar from './Header';
    import FooterEnd from './Footer';

    const { Content } = Layout;

    interface MasterProps {
        children: ReactNode;
    }



    const Master: React.FC<MasterProps> = ({ children }) => {

        const [collapsed, setCollapsed] = useState(false);
        const [hover, setHover] = useState(false);
        // const [headerName, setHeaderName] = useState('');
        const [isSmallScreen, setIsSmallScreen] = useState(false);
        

        const SecondStyle = !isSmallScreen ? '' : '';

        const headerStyle = {
            marginLeft: `${SecondStyle}`,
        };

        const handleResize = () => {
            if (window.innerWidth <= 900) {
                setIsSmallScreen(true);
                setCollapsed(false);
            }
            else {
                setIsSmallScreen(false);
            }
        };

        useEffect(() => {
            handleResize();
            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);



        const toggleSidebar = () => {
            localStorage.setItem('collapsed', String(!collapsed));
            setCollapsed(!collapsed);
        };

        const handleMouseEnter = () => {
            if (hover) {
                setCollapsed(false);
            }
        };

        const handleMouseLeave = () => {
            if (hover) {
                setCollapsed(true);
            }
        };

        const disableHoverEffect = () => {
            setHover(!hover);
        };

        return (
            <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>
                <Sidebar
                    collapsed={collapsed}
                    onCollapse={toggleSidebar}
                    hoverEffectActive={hover}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    isSmallScreen={isSmallScreen}
                    style={{
                        position: 'fixed',
                        height: '100vh',
                        overflow: 'hidden', // Prevent the sidebar from scrolling
                        zIndex: 1000,      // Ensure it stays above the content
                    }}
                />
                <Layout
                    style={{
                        marginLeft: collapsed ? '' : '', // Adjust this based on your collapsed width
                        transition: 'margin-left 0.3s',          // Smooth transition for sidebar toggle
                        overflow: 'hidden',
                        backgroundColor: '#FFF8EC'
                    }}
                >
                    <Navbar
                        collapsed={collapsed}
                        toggleSidebar={toggleSidebar}
                        disableHoverEffect={disableHoverEffect}
                        style={{
                            top: 0,
                            zIndex: 999,  // Keep the navbar above the content
                            backgroundColor: '#ffffff',
                        }}
                    />
                    <Content
                        style={{
                            margin: '16px',
                            padding: '16px',
                            overflow: 'auto', // Allow scrolling only within the content area
                            backgroundColor: '#FFF8EC',
                            height: 'calc(100vh - 64px)', // Adjust to subtract the navbar height
                        }}
                    >
                        {children}
                    </Content>
                    <FooterEnd />
                </Layout>
            </Layout>
        );
        
    };

    export default Master;
